import React from 'react';
import { func, bool, string, number, array, object } from 'prop-types';
import classNames from 'classnames';

import { AmenityCategoryHeader, AmenityCategoryContent } from '../../components';
import css from './AmenityCategoryItem.module.css';

const AmenityCategoryItem = props => {
  const {
    category,
    isExpanded,
    selectedAmenities,
    customAmenities,
    wifiSpeeds,
    onToggle,
    onAmenitySelect,
    onAmenityDeselect,
    onAddCustomClick,
    onCustomAmenityRemove,
    className,
    rootClassName,
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  // Calculate selection count (including custom amenities)
  const selectedCount = selectedAmenities.length;

  return (
    <div className={classes}>
      <AmenityCategoryHeader
        categoryName={category.name}
        selectedCount={selectedCount}
        isExpanded={isExpanded}
        onClick={onToggle}
      />
      {isExpanded && (
        <AmenityCategoryContent
          amenities={category.amenities}
          selectedAmenities={selectedAmenities}
          customAmenities={customAmenities}
          wifiSpeeds={wifiSpeeds}
          onAmenitySelect={onAmenitySelect}
          onAmenityDeselect={onAmenityDeselect}
          onAddCustomClick={onAddCustomClick}
          onCustomAmenityRemove={onCustomAmenityRemove}
        />
      )}
    </div>
  );
};

AmenityCategoryItem.defaultProps = {
  isExpanded: false,
  selectedAmenities: [],
  customAmenities: [],
  wifiSpeeds: null,
  className: null,
  rootClassName: null,
};

AmenityCategoryItem.propTypes = {
  category: object.isRequired,
  isExpanded: bool,
  selectedAmenities: array,
  customAmenities: array,
  wifiSpeeds: object,
  onToggle: func.isRequired,
  onAmenitySelect: func.isRequired,
  onAmenityDeselect: func.isRequired,
  onAddCustomClick: func.isRequired,
  onCustomAmenityRemove: func.isRequired,
  className: string,
  rootClassName: string,
};

export default AmenityCategoryItem;
